import { ImageComponent } from "fwork.react.apptemplate"
import React, { useEffect, useState } from "react"
import { default as imageDefaultShield } from '../../assets/escudo.jpg'
import { uuidv7 } from 'uuidv7'

interface ParticipantImgComponentProps {
  id: number
}

export const ParticipantImgComponent = ({ id }: ParticipantImgComponentProps) => {
  // const dotEnvProductionState = store.getState().dotEnvProductionState

  const imageUrl = `https://assets.aposte.bet/${id}_s.png?v=${uuidv7()}`
  const [image, setImage] = useState(imageUrl)

  useEffect(() => {
    setImage(imageUrl)
  }, [id])

  return (
    <ImageComponent
      src={image}
      // onError={() => setImgState({ url: imageDefaultShield })}
      onError={() => setImage(imageDefaultShield)}
      style={{ width: 45, height: 45, cursor: 'pointer' }}
    />
  )
}
